import { index, inventory, show, store, update, destroy,getStaffList,expenseStore, getApiExpenses } from "@/api/settings/businessTrip";

export const actions = {
    index({ commit }, params = {}) {
        return new Promise((resolve, reject) => {
            index(params)
                .then(res => {
                    commit("SET_LIST", res.data.result.data.business_trips);
                    commit("UPDATE_PAGINATION", { key: 'total', value: res.data.result.data.pagination.total });
                    resolve(res.data.result.data.business_trips);
                })
                .catch(err => {
                    reject(err.response.data);
                });
        }); 
    },

    inventory({ commit }, params = {}) {
        return new Promise((resolve, reject) => {
            inventory(params).then(res => {
                commit("SET_INVENTORY", res.data.result.data.business_trips);
                resolve(res.data)
            }).catch(err => {
                reject(err.response.data)
            })
        })
    },
    getCompaniesInfo({ commit }, params = {}) {
      return new Promise((resolve, reject) => {
          getCompaniesInfo(params)
              .then(res => {
                  commit("SET_COMPANIES_INFO", res.data.result.data.companies);
                  // commit("UPDATE_PAGINATION", { key: 'total', value: res.data.result.data.pagination.total });
                  resolve(res.data.result.data.companies);
              })
              .catch(err => {
                  reject(err.response.data);
              });
      }); 
  },
    getStaffList({ commit }, params={}) {
      return new Promise((resolve, reject) => {
        getStaffList(params)
              .then(res => {
                  commit("SET_STAFF_LIST", res.data.result.data.staffs);                    
                  resolve(res.data.result.data.staffs);
              })
              .catch(err => {
                  reject(err.response.data);
              });
      });
    },
    getExpenses({ commit }, params={}) {
      return new Promise((resolve, reject) => {
        getApiExpenses(params)
              .then(res => {
                  commit("SET_EXPENSES", res.data.result.data.expenses);                    
                  resolve(res.data.result.data.expenses);
              })
              .catch(err => {
                  reject(err.response.data);
              });
      });
    },
    show({ commit }, id) {
        return new Promise((resolve, reject) => {
            show(id)
                .then(res => {
                    commit('SET_MODEL', res.data.result.data.business_trip);
                    resolve(res);
                })
                .catch(err => {
                    reject(err.response.data);
                });
        });
    },

    store({ commit }, data) {
        return new Promise((resolve, reject) => {
            store(data)
                .then(res => {
                    resolve(res);
                })
                .catch(err => {
                    reject(err);
                });
        });
    },

    expenseStore({ commit }, data) {
      return new Promise((resolve, reject) => {
          expenseStore(data)
              .then(res => {
                  resolve(res);
              })
              .catch(err => {
                  reject(err);
              });
      });
    },

    update({ commit }, data) {
        return new Promise((resolve, reject) => {
            update(data)
                .then(res => {
                    resolve(res);
                })
                .catch(err => {
                    reject(err);
                });
        });
    },

    empty({ commit }) {
        return new Promise((resolve, reject) => {
            commit("EMPTY_MODEL");
            resolve()
        })
    },

    destroy({ commit }, id) {
        return new Promise((resolve, reject) => {
            destroy(id)
                .then(res => {
                    resolve(res);
                })
                .catch(err => {
                    reject(err);
                });
        });
    },
    updateSort({ commit }, sort) {
        commit("SET_SORT", sort)
    },

    updateFilter({ commit }, filter) {
        commit('SET_FILTER', JSON.parse(JSON.stringify(filter)))
    },

    updateColumn({ commit }, obj) {
        commit('UPDATE_COLUMN', obj)
    },
    updatePagination({ commit }, pagination) {
        commit('UPDATE_PAGINATION', pagination)
    },
    refreshData({ commit }) {
        return new Promise((resolve, reject) => {
            commit("REFRESH");
            resolve()
        })
    },
};
